import { useEffect } from 'react';

export default function useOnMount(initializer: () => void) {
  useEffect(() => {
    initializer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
